export const TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const PREFIX = '/api';
